module.exports = __webpack_public_path__ + "static/media/ticket.e8d3eefe.svg";